import { requestApi } from "../funcitons"
import tokenUtils from "../../utils/token"

export default {
    login: async (email, password) => {
        const res = await requestApi('users/login', 'POST', {
            email,
            password
        });

        if(res.status === 200) {
            tokenUtils.setToken(res.data.token);
            return res.data;
        }else{
            //Failed
        }
    },
    register: async (email, password, secret_code) => {
        const res = await requestApi('users/register', 'POST', {
            email,
            password,
            secret_code,
        });

        if(res.status === 200) {
            tokenUtils.setToken(res.data.token);
            return res.data;
        }else{
            //Failed
        }
    },
}